import { h } from "preact";

import style from "./style";

/**
 * A component that displays a list of links. Children should be <Link> elements
 * @param {any} param0 Child components
 */
const LinkList = ({ children = [] }) => (
  <ul class={style["link-list"]}>
    {children.length > 0 && children.map((child, index) => <li key={index}>{child}</li>)}
  </ul>
);

export default LinkList;
